<template>
  <div>

    <create-team-definition-popup
      v-if="showAddModal"
      @close="showAddModal = false"
      @submitted="refreshData(); showAddModal = false;"
    />

    <b-card
      no-body
      class="mb-0"
    >

      <table-top
        show-add-button
        show-search
        @change:limit="limitChanged"
        @change:query="queryChanged"
        @click:add="showAddModal = true "
      />

      <rc-overlay :show="loading">
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="teamDefinitions"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          :empty-text="loading ? $t('shared.loading') : $t('shared.no-data') "
          :sort-by.sync="query.sortBy"
          :sort-desc.sync="query.isSortDirDesc"
        >

          <!-- Column: Code -->
          <template #cell(code)="data">
            <b-media vertical-align="center">
              <b-link
                :to="{ name: 'settings-team-definition-edit', params: { id: data.item.id } }"
                class="font-weight-bold d-block text-nowrap"
              >
                {{ data.item.code }}
              </b-link>
            </b-media>
          </template>

          <!-- Column: Capabilities -->
          <template #cell(capabilities)="data">
            <div class="text-nowrap">
              <b-badge
                v-if="data.item.driverOnly"
                variant="light-warning"
              >
                {{ $t('conf.settings.team-definition.badge.driver-only') }}
              </b-badge>
              <b-badge
                v-else-if="data.item.allowDriverAsParamedic"
                variant="light-primary"
              >
                {{ $t('conf.settings.team-definition.badge.allow-driver-as-paramedic') }}
              </b-badge>
            </div>
          </template>

          <template #cell(planner)="data">
            <b-badge :variant="data.item.displayInPlanner ? 'light-success' : 'light-secondary'">
              {{ data.item.displayInPlanner ? $t('shared.yes') : $t('shared.no') }}
            </b-badge>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">

            <div class="text-nowrap">
              <feather-icon
                icon="EditIcon"
                class="cursor-pointer"
                size="16"
                @click="editTeamDefinition(data.item.id)"
              />
              <b-tooltip
                :title="$t('shared.edit')"
                class="cursor-pointer"
                :target="`invoice-row-${data.item.id}-send-icon`"
              />
            </div>

          </template>

        </b-table>
      </rc-overlay>

      <table-bottom
        :query="query"
        :total="total"
      />
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BLink, BMedia, BTable, BTooltip,
} from 'bootstrap-vue'
import TableTop from '@/layouts/components/table/TableTop.vue'
import CreateTeamDefinitionPopup from '@/views/settings/TeamDefinition/popups/CreateTeamDefinitionPopup.vue'
import TableBottom from '@/layouts/components/table/TableBottom.vue'
import RcOverlay from '@/layouts/components/rc/RcOverlay.vue'
import { parseRequestError } from '@/helpers/helpers'

export default {
  components: {
    TableBottom,
    CreateTeamDefinitionPopup,
    TableTop,
    RcOverlay,

    BCard,
    BTable,
    BMedia,
    BLink,
    BTooltip,
  },
  data() {
    return {
      showAddModal: false,
      loading: false,

      total: 0,
      query: {
        sortBy: null,
        isSortDirDesc: false,
        query: null,
        limit: 10,
        page: 1,
      },

      tableColumns: [
        {
          label: this.$t('conf.settings.team-definition.code'),
          key: 'code',
          sortable: true,
        },
        {
          label: this.$t('conf.settings.team-definition.form.phone'),
          key: 'phoneNumber',
          sortable: true,
        },
        {
          label: this.$t('conf.settings.team-definition.table.capabilities'),
          key: 'capabilities',
        },
        {
          label: this.$t('conf.settings.team-definition.table.planner'),
          key: 'planner',
        },
        {
          label: this.$t('shared.actions'),
          key: 'actions',
          value: null,
          class: 'actions-column',
        },
      ],
    }
  },
  computed: {
    teamDefinitions() {
      return this.$store.state.settings.teamDefinitions
    },
  },
  watch: {
    query: {
      handler() {
        this.refreshData()
      },
      deep: true,
    },
  },
  created() {
    this.refreshData()
  },
  methods: {
    refreshData() {
      this.loading = true
      const query = {
        q: this.query.query,
        sortField: this.query.sortBy,
        sortDir: this.query.isSortDirDesc ? 'desc' : 'asc',
        limit: this.query.limit,
        page: this.query.page,
      }

      Promise.all([this.$store.dispatch('settings/fetchTeamDefinitions', query)])
        .then(res => {
          if (this.query.page > 1 && res[0].data.items.length === 0) {
            this.query.page = 1
          }

          this.total = res[0].data.total
          this.loading = false
        })
        .catch(err => parseRequestError(err))
    },
    deleteTeamDefinition(id) {
      return id
    },
    editTeamDefinition(id) {
      this.$router.push(`/settings/team-definition/edit/${id}`)
    },
    limitChanged(newLimit) {
      this.query.limit = newLimit
    },
    queryChanged(newQuery) {
      this.query.query = newQuery
    },
  },
}
</script>

<style lang="scss">

.actions-column {
  width: 1rem;
}
</style>
